<template>
  <div
    v-if="activeDialog"
    class="overlay"
    :class="activeDialog ? 'active': ''"
  >
    <div id="dialoge_close" class="screenshot-wrapper">
      <div class="close-dialog" @click="closePopups">
        <WhiteCloseIcon28 />
      </div>
      <div v-if="session.currentScreenshot" class="popup-wrapper">
        <span>{{ reformatTime(session.currentScreenshot.createdAt) }}</span>
        <div class="screen-section">
          <div
            class="back-button"
            :class="{ 'disabled': session.screenPage === 0 }"
            @click="prevPage"
          >
            <arrowDown class="arrow" />
          </div>
          <img :src="session.currentScreenshot.link" alt="screenshot">
          <div
            class="forward-button"
            :class="{ 'disabled': session.screenPage >= session.screenshots.length - 1 }"
            @click="nextPage"
          >
            <arrowDown class="arrow" />
          </div>
        </div>
        <div class="popup-session-info">
          <div class="email">
            <span>Email</span>
            <div>{{ session.email }}</div>
          </div>
          <div class="device">
            <span>Device</span>
            <div>
              <PhoneIcon32 />
              {{ session.device }}
            </div>
          </div>
          <div class="session">
            <span>Session</span>
            <div>#{{ session.sessionId }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArrowDown from '@/components/icons/ArrowDown';
import reformatDateToTime from '@/mixins/reformatDateToTime';
import WhiteCloseIcon28 from '@/components/icons/WhiteCloseIcon28.vue';
import PhoneIcon32 from '@/components/icons/PhoneIcon32.vue';

export default {
  name: 'ScreenshotPopup',
  components: {
    PhoneIcon32,
    WhiteCloseIcon28,
    ArrowDown
  },
  mixins: [reformatDateToTime],
  emits: ['closed'],
  props: {
    session: {
      type: Object,
      default: () => ({
        currentScreenshot: null,
        email: '',
        device: '',
        sessionId: '',
        screenPage: 0,
        screenshots: []
      })
    }
  },
  data() {
    return {
      activeDialog: false,
    };
  },
  methods: {
    openPopups() {
      this.activeDialog = true;
    },
    closePopups() {
      this.activeDialog = false;
      this.$emit('closed');
    },
    nextPage() {
      if (this.session.screenPage < this.session.screenshots.length - 1) {
        this.session.screenPage++;
        this.session.currentScreenshot = this.session.screenshots[this.session.screenPage];
      }
    },
    prevPage() {
      if (this.session.screenPage > 0) {
        this.session.screenPage--;
        this.session.currentScreenshot = this.session.screenshots[this.session.screenPage];
      }
    }
  }
};
</script>

<style>
@keyframes show {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.overlay.active {
  animation: show .3s linear;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.screenshot-wrapper {
  width: fit-content;
  max-width: 90%;
  max-height: 90%;
  height: fit-content;
  border: 1px solid #D7DCE6;
  box-sizing: border-box;
  border-radius: 30px;
  padding: 40px 10px;
  background: #fff;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
}

.close-dialog {
  width: 70px;
  height: 70px;
  padding: 23px 23px 10px;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.close-dialog svg {
  width: 100%;
  height: 100%;
}

.close-dialog svg path {
  transition: .5s all;
}

.close-dialog:hover svg path {
  fill: var(--accent-color);
}

.close-dialog img {
  display: block;
  width: 100%;
}

/* Styles from CustodianSessionsList.vue */
.popup-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1100px;
  height: 900px;
  margin: 20px 0 0;
  gap: 15px;
}

.popup-wrapper span {
  display: block;
  font-size: 18px;
  font-weight: 700;
  line-height: 21.78px;
  text-align: left;
  color: var(--secondary-black-color);
}

.screen-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 45px;
  width: 1000px;
  height: 600px;
}

.screen-section img {
  max-width: 800px;
}

.popup-session-info {
  display: flex;
  justify-content: space-between;
  max-width: 90%;
  width: 100%;
  max-height: 70px;
  height: 100%;
  padding: 15px 0 0;
  border-top: 1px solid var(--case-btn-border-color);
}

.popup-session-info .email,
.popup-session-info .device,
.popup-session-info .session {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: fit-content;
}

.popup-session-info .email span,
.popup-session-info .device span,
.popup-session-info .session span {
  display: inline-block;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  text-align: left;
  color: var(--secondary-black-color);
}

.popup-session-info .email div,
.popup-session-info .device div,
.popup-session-info .session div {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  text-align: left;
  color: var(--secondary-text-color);
  gap: 8px;
}

.back-button,
.forward-button {
  width: 37px;
  height: 81px;
  padding: 30px 8px;
  border-radius: 8px;
  border: 1px solid #EBEFF6;
  cursor: pointer;
}

.back-button .arrow {
  width: 21px;
  height: 21px;
  transform: rotate(90deg);
}

.forward-button .arrow {
  width: 21px;
  height: 21px;
  transform: rotate(-90deg);
}

.disabled {
  opacity: 0.2;
}
</style>